import { useErrorHandler } from 'onyx-common/react-error-boundary'

export default useErrorHandler
